<template>
  <div class="device-verify">
    <SameContent>
      <div v-if="loading" class="device-msg">
        <Loading />
      </div>
      <div v-if="!loading" class="device-msg">
        <div class="title">
          您所使用的设备为
        </div>
        <div v-if="isTrue" class="name">
          {{ msg.info }}
        </div>
        <div v-if="isTrue" class="name">
          正品设备&nbsp;请放心使用
        </div>
        <div v-if="!isTrue" class="name">
          您输入的认证服务商信息不存在。
        </div>
        <div v-if="!isTrue" class="name">
          请谨防假冒
        </div>
        <div v-if="isTrue">
          <div class="item first">
            <span class="label">所属机构：</span>{{ msg.organization }}
          </div>
          <div class="item">
            <span class="label">版权所有：</span>
            <div class="value">
              <p>{{ msg.mandateInfo }}</p>
              <p>{{ msg.proxyCompany }}</p>
            </div>
          </div>
          <div class="item">
            {{ msg.mandateProduct }}
          </div>
          <div class="item">
            特此认证
          </div>
          <div class="item second">
            授权期限：{{ msg.startTime }} 至 {{ msg.endTime }}
          </div>
          <div class="item">
            授权编号：{{ msg.code }}
          </div>
          <div class="item third">
            签发日期：{{ msg.signTime }}
          </div>
        </div>
      </div>
      <div class="verify-unit">
        <div class="item">
          认证单位
        </div>
        <div class="item">
          长沙正云祥医疗器械科技有限公司
        </div>
        <div class="item">
          认证查询微信公众号“MEIDASHI”
        </div>
        <div class="btn">
          完成查询
        </div>
      </div>
    </SameContent>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import SameContent from '@/components/SameContent'
import { queryEquipmentInfo } from '@/api/common'
export default {
  name: 'DeviceVerify',
  components: {
    SameContent,
    Loading
  },
  data() {
    return {
      loading: false,
      msg: {
        code: '',
        endTime: '',
        info: '',
        mandateInfo: '',
        mandateProduct: '',
        organization: '',
        proxyCompany: '',
        signTime: '',
        startTime: ''
      },
      isTrue: false
    }
  },
  mounted() {
    this.loading = true
    let code = this.$route.query.code
    if (code) {
      queryEquipmentInfo(code).then(res => {
        let { content, success, errorType } = res.data
        if (success && errorType === '00000000') {
          if (!content) {
            this.isTrue = false
            alert('您输入的认证服务商信息不存在，谨防假冒。')
          } else {
            this.msg = content
            this.isTrue = true
          }
        } else {
          alert('查询失败，请稍后再试！')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        alert('查询失败，请稍后再试！')
      })
    } else {
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.device-verify{
  width: 100%;
  height: 100%;
  position: relative;
  .device-msg{
    width: 621px;
    height: 755px;
    background: url('~images/device-bg.png') no-repeat left top;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 220px;
    transform: translateX(-50%);
    .title{
      text-align: center;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #737579;
      margin-top: 60px;
      padding-bottom: 20px;
    }
    .name{
      font-size: 34px;
      font-family: Hiragino Sans GB;
      font-weight: 600;
      color: #438AF2;
      margin-top: 10px;
      text-align: center;
    }
    .item{
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #171717;
      line-height: 1.7;
      padding: 0 40px;
      text-align: left;
      display: flex;
      &.first{
        margin-top: 40px;
      }
      &.second{
        margin-top: 20px;
      }
      &.third{
        display: block;
        margin-top: 20px;
        text-align: right;
      }
      .label {
        min-width: 130px;
        white-space: nowrap;
      }
    }
  }
  .verify-unit{
    padding-top: 310px;
    overflow: auto;
    .item{
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #737579;
      line-height: 1.7;
    }
  }
  .btn{
    width: 238px;
    height: 80px;
    background: #96C1F9;
    box-shadow: 0px 4px 10px 0px rgba(76, 109, 189, 0.55);
    border-radius: 10px;
    text-align: center;
    line-height: 80px;
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin: 30px auto 60px;
  }
}
</style>
